import React from 'react';
import styles from './GameSetupForm.module.css';
import { GameMode } from '../../types/collection';
import { GAME_MODES } from '../../constants/gameModes';
import { Rating, RATING_OPTIONS } from '../../constants/rating';

interface GameSetupFormProps {
  gameMode: GameMode;
  onGameModeChange: (mode: GameMode) => void;
  rating: Rating;
  onRatingChange: (rating: Rating) => void;
  artists: string;
  rounds: number;
  isLoading: boolean;
  error: string | null;
  onArtistsChange: (value: string) => void;
  onRoundsChange: (value: number) => void;
  onStartGame: (e: React.FormEvent) => void;
  showFavorites: boolean;
  onShowFavoritesChange: (value: boolean) => void;
  difficulty: number | null;
  onDifficultyChange: (value: number | null) => void;
  isRanked: boolean;
}

const GameSetupForm: React.FC<GameSetupFormProps> = ({
  gameMode,
  onGameModeChange,
  rating,
  onRatingChange,
  artists,
  rounds,
  isLoading,
  error,
  onArtistsChange,
  onRoundsChange,
  onStartGame,
  showFavorites,
  onShowFavoritesChange,
  difficulty,
  onDifficultyChange,
  isRanked,
}) => {
  return (
    <form onSubmit={onStartGame} className={styles.form}>
      <div className={styles.filterGroup}>
        <label htmlFor="gameMode">Game Mode:</label>
        <select
          id="gameMode"
          value={gameMode}
          onChange={(e) => onGameModeChange(e.target.value as GameMode)}
          className={styles.select}
          disabled={isRanked}
        >
          {GAME_MODES.map((mode) => (
            <option key={mode.id} value={mode.id}>
              {mode.label}
            </option>
          ))}
        </select>
      </div>
      <div className={styles.filterGroup}>
        <label htmlFor="rating">Rating:</label>
        <select
          id="rating"
          value={rating}
          onChange={(e) => onRatingChange(e.target.value as Rating)}
          className={styles.select}
          disabled={isRanked}
        >
          {RATING_OPTIONS.map((option) => (
            <option key={option.id} value={option.id}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
      <div className={styles.filters}>
        <div className={styles.filterGroup}>
          <label>
            <input
              type="checkbox"
              checked={showFavorites}
              onChange={(e) => onShowFavoritesChange(e.target.checked)}
              disabled={isRanked}
            />
            Favorites Only
          </label>
        </div>
        <div className={styles.filterGroup}>
          <span>Difficulty:</span>
          <label>
            <input
              type="radio"
              name="difficulty"
              checked={difficulty === null}
              onChange={() => onDifficultyChange(null)}
              disabled={isRanked}
            />
            All
          </label>
          <label>
            <input
              type="radio"
              name="difficulty"
              value="1"
              checked={difficulty === 1}
              onChange={() => onDifficultyChange(1)}
              disabled={isRanked}
            />
            1
          </label>
          <label>
            <input
              type="radio"
              name="difficulty"
              value="2"
              checked={difficulty === 2}
              onChange={() => onDifficultyChange(2)}
              disabled={isRanked}
            />
            2
          </label>
          <label>
            <input
              type="radio"
              name="difficulty"
              value="3"
              checked={difficulty === 3}
              onChange={() => onDifficultyChange(3)}
              disabled={isRanked}
            />
            3
          </label>
        </div>
      </div>
      {/* <div className={styles.presetButtons}>
        <button type="button" onClick={() => handlePresetClick({ artists: practiceArtists })}>
          Practice
        </button>
        <button type="button" onClick={() => handlePresetClick({ artists: easyArtists })}>
          Easy
        </button>
        <button type="button" onClick={() => handlePresetClick({ artists: hardArtists })}>
          Hard
        </button>
        <button type="button" onClick={() => handlePresetClick(customArtists)}>
          Custom
        </button>
      </div> */}
      <div className={styles.inputGroup}>
        <label htmlFor="artists">Artist Tags (separated by commas, spaces, or new lines):</label>
        <textarea
          id="artists"
          value={artists}
          onChange={(e) => onArtistsChange(e.target.value)}
          placeholder="e.g., takeuchi_takashi, k-eke"
          className={styles.textarea}
          rows={5}
          disabled={isRanked}
        />
      </div>
      <div className={styles.inputGroup}>
        <label htmlFor="rounds">Number of Rounds:</label>
        <input
          id="rounds"
          type="number"
          value={rounds}
          onChange={(e) => onRoundsChange(parseInt(e.target.value, 10))}
          min="1"
          max="20"
          className={styles.input}
          disabled={isRanked}
        />
      </div>
      <button type="submit" className={styles.button} disabled={isLoading}>
        {isLoading ? 'Starting...' : 'Start Game'}
      </button>
      {error && <p className={styles.error}>{error}</p>}
    </form>
  );
};

export default GameSetupForm; 